import MsgShow from '@/components/dialog/MsgShow.vue'
let ConfirmConstructor, instance

const showMsgShow = {
  install(Vue) {
    ConfirmConstructor = Vue.extend(MsgShow)
    instance = new ConfirmConstructor().$mount()
    document.body.appendChild(instance.$el)

    Vue.prototype.$showMsgShow = options => {
      Object.assign(instance, options)
      instance.init()
    }

  }
}

export default showMsgShow


// WEBPACK FOOTER //
// ./src/assets/js/msgShow.js